import * as config from 'config';

// ------------------------------------------------------------------------
// Bugsnag
// ------------------------------------------------------------------------
if (config.BUGSNAG_API_KEY) {
    require('boot/bugsnag');
}


// ------------------------------------------------------------------------
// Polyfills
// ------------------------------------------------------------------------
require('boot/polyfills');


// ------------------------------------------------------------------------
// Other Libraries
// ------------------------------------------------------------------------


// ------------------------------------------------------------------------
// Vue
// ------------------------------------------------------------------------
require('boot/vue');


// ------------------------------------------------------------------------
// Enable Barba.js Page Transitions
// ------------------------------------------------------------------------
// require('barba');


// ------------------------------------------------------------------------
// Axios
// ------------------------------------------------------------------------
window.axios = require('axios');

// axios.defaults.baseURL = config.API_PREFIX
axios.defaults.headers.common = {
    // 'Authorization': 'Bearer ' + config.API_TOKEN,
    // 'X-CSRF-TOKEN': window.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
};


// ------------------------------------------------------------------------
// Component Hooks
// (Keep the "hook" line below)
// ------------------------------------------------------------------------
// $cli-hook-tools-init$
require('components/buttonBar/boot');
require('components/dropdown/boot');
require('components/photoswipe/boot/index');

require('components/responsiveImage/boot/index');

require('components/filterableList/boot');
